import React from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { updateBusinessMeetingAction } from "../../actions/bookOfBusiness";
import { useEffect } from "react";
import { CUSTOM_SELECT_STYLES, SELECT_BOX_THEME, TZ } from "../../constants";
import { useCallback } from "react";
import Select from "react-select";

export default function SendToChat({
  meetingOpen,
  meetingClose,
  handleConnect,
  item
}) {
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();

  const { allUserList } = useSelector((state) => state.user);
  console.log(item)
  const onSubmit = async (values) => {
    const payload = {
      userDetail: values.userDetail,
    }
    handleConnect(payload)
    reset();
  }

  return (
    <Modal
      show={meetingOpen}
      onHide={() => { meetingClose() }}
      className="moddal-primary importModal confirmMeeting ps-0"
    >
      <Modal.Body>
        <div className="header">
          <div>
            <h4>Profile detail</h4>
          </div>
          <i
            onClick={() => { meetingClose(); }}
            className="fa-solid fa-xmark"
          ></i>
        </div>

        <div className="modalBody importSampleFile">
          <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <div className="note">
              <div className="row">
                <div className="col-md-12 mt-2 mb-2">
                  <p className="profileDesc">
                    <span className="profileName">Name:</span> {item?.name}
                  </p>
                  <p className="profileDesc">
                    <span className="profileName">About:</span> {item?.about}
                  </p>
                </div>
                <div className="col-md-12">
                  <label className="input-text heading">Select user</label>

                  <div className="form-group message-section">
                    <Controller
                      rules={{ required: "Select user" }}
                      render={({ field: { value, onChange } }) => (
                        <Select
                          theme={SELECT_BOX_THEME}
                          styles={CUSTOM_SELECT_STYLES}
                          options={allUserList}
                          getOptionLabel={(option) => `${option.first_name} ${option.last_name} (${option.email})`}
                          getOptionValue={(option) => option.email}
                          value={value}
                          onChange={(value) => {
                            console.log("value", value)
                            onChange(value)
                          }}
                          placeholder="Invite people to join the conversation..."
                        />
                      )}
                      name="userDetail"
                      control={control}
                    />
                  </div>
                </div>
                {errors.userDetail?.type === "required" && (
                  <span className="errorMessage">Please select user to send message</span>
                )}
              </div>
            </div>
            <div className="importBtn">
              <button
                type="submit"
                className={`customAddButton removePadding`}
              >
                Send Profile
              </button>
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
}
